/**
 * Post Like and Comment Buttons Component
 * Displays the like and comment toggle buttons for a post.
 */

import React from 'react';
import { Heart, MessageCircle, Bookmark, Repeat2, Share2, Check, Flag } from 'lucide-react';

const PostLikeAndCommentButtons = ({
  isLiked,
  likesCount,
  commentsCount,
  onLikeClick,
  onCommentToggle,
  isAuthenticated,
  isBookmarked,
  onBookmarkClick,
  isReposted,
  onRepostClick,
  onShareClick,
  shareCopied,
  onReportClick
}) => {
  return (
    <div className="post-actions">
      <button
        type="button"
        className={`like-btn ${isLiked ? 'liked' : ''}`}
        onClick={onLikeClick}
        title={!isAuthenticated ? 'Login to like' : ''}
      >
        <Heart size={20} fill={isLiked ? 'currentColor' : 'none'} />
        <span>{likesCount}</span>
      </button>
      <button type="button" onClick={onCommentToggle}>
        <MessageCircle size={20} />
        <span>{commentsCount}</span>
      </button>
      {onRepostClick && (
        <button
          type="button"
          className={`repost-btn ${isReposted ? 'reposted' : ''}`}
          onClick={onRepostClick}
          title={isReposted ? 'Reposted' : 'Repost'}
        >
          <Repeat2 size={20} />
        </button>
      )}
      {onShareClick && (
        <button
          type="button"
          className={`share-btn ${shareCopied ? 'copied' : ''}`}
          onClick={onShareClick}
          title="Copy link to post"
        >
          {shareCopied ? <Check size={20} /> : <Share2 size={20} />}
          {shareCopied && <span className="share-copied">Copied!</span>}
        </button>
      )}
      {onBookmarkClick && (
        <button
          type="button"
          className={`bookmark-btn ${isBookmarked ? 'bookmarked' : ''}`}
          onClick={onBookmarkClick}
          title={isBookmarked ? 'Saved' : 'Save post'}
        >
          <Bookmark size={20} fill={isBookmarked ? 'currentColor' : 'none'} />
        </button>
      )}
      {onReportClick && (
        <button
          type="button"
          className="report-btn"
          onClick={onReportClick}
          title="Report post"
        >
          <Flag size={18} />
        </button>
      )}
    </div>
  );
};

export default PostLikeAndCommentButtons;
